import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  selectNewOrdersNotifications,
  selectSystemNotifications
} from '@/ducks/notifications/selectors/notificationsSelectors'
import {
  addNewOrderNotification,
  addSystemNotification,
  IToast,
  removeNotificationNew
} from '@/ducks/notifications/slices/notification.slice'

export const useToaster = () => {
  const dispatch = useDispatch()

  const system = useSelector(selectSystemNotifications)
  const newOrders = useSelector(selectNewOrdersNotifications)

  const addToast = useCallback(
    (toast: IToast) => {
      if (toast.type === 'newOrder') {
        dispatch(addNewOrderNotification(toast))
      } else {
        if (toast.type === 'system')
          dispatch(addSystemNotification({ ...toast, type: 'system' }))
      }
    },
    [dispatch]
  )

  const removeToast = useCallback(
    (id: number) => {
      dispatch(removeNotificationNew(id))
    },
    [dispatch]
  )

  return {
    system,
    newOrders,
    addToast,
    removeToast
  }
}
